import React                        from 'react';
import PropTypes                    from 'prop-types';
import ReloadHelper                 from '../../../utils/ReloadHelper';
import Translations                 from '../../../utils/Translations';
import UrlBuilder                   from '../../../utils/UrlBuilder';
import DailybonusTodayOfferHeadLine from './DailybonusTodayOfferHeadLine';
import AgeRestrictionLabel          from '../SubComponents/AgeRestrictionLabel';
import AlbumPriceLabel              from '../SubComponents/AlbumPriceLabel';
import ContentLink                  from '../SubComponents/ContentLink';
import DailyBonusOfferBtn           from '../SubComponents/DailyBonusOfferBtn';
import FreeContentLabel             from '../SubComponents/FreeContentLabel';
import OfferIcon                    from '../SubComponents/OfferIcon';
import VipBadge                     from '../SubComponents/VipBadge';
import { formatEffectAsPlainText,
	isCurrencyVoucher }             from '../dailyBonusHelpers';
import Flux                         from '../../../flux/Flux.js';


class DailybonusTodayPhotoOffer extends React.Component {

	constructor(props) {
        super(props);
		this.onClickHandler = this.onClickHandler.bind(this);
	}

	onClickHandler(e) {
		ReloadHelper.reload(e.currentTarget.href, e);
	}

	render() {
		const {
			      content,
			      conditions,
			      offer,
			      purchased,
			      effect,
			      quantity,
			      free,
		      }                = this.props;
		const {
			      model,
			      photos,
			      ageRating,
			      dailyBonusPrice,
				  price,
				  basePrice,
			      photosCount,
			      title,
			      preview,
			      hidden,
			      linkVX,
		      }                = content ? content : {};
		let previews           = [];
		const contentAvailable = !hidden || purchased;
		const isVoucher        = isCurrencyVoucher(price);

		if (content && photos) {
			previews = photos.slice(0, 4);
		}

		if (content && typeof photos === 'undefined' && preview) {
			previews.push(preview);
		}

		if (previews.length < 1) {
			previews.push({url: '/assets/img/placeholder.jpg'});
		}

		const overviewsBlock = previews && previews.map((img, index) => (
			<div key={index}
			     className={previews.length === 1 ? 'img-full' : 'img-grid'}
			     style={{backgroundImage: `url(${img.url})`}}
			/>
		));

		return (
			<div className='dailybonus-today-item'>
				<DailybonusTodayOfferHeadLine
					purchased={purchased}
					offer={offer}
				/>
				<div className="dailybonus-today-item__wrapper">
					<div className="dailybonus-today-item__left-side">
						<ContentLink link={linkVX} enabled={contentAvailable}>
							<span className="dailybonus-today-item__left-side__background">{overviewsBlock}</span>
						</ContentLink>
						<div className="dailybonus-today-item__left-side--budgeses">
							<AgeRestrictionLabel ageRating={ageRating} />
							{content && !free && (<AlbumPriceLabel price={price} basePrice={basePrice} discountedPrice={dailyBonusPrice} purchased={purchased} />)}
							<FreeContentLabel free={free} />
						</div>
						<div className="dailybonus-today-item__left-side--bottom-plate">
							<div className="dailybonus-today-item__left-side--bottom-plate__title">
								<ContentLink link={linkVX} enabled={contentAvailable}>
									{content ? title : ''}
								</ContentLink>
							</div>
							<div className="dailybonus-today-item__left-side--bottom-plate__detail">
								{content && <span className='grey'>{photosCount} {Translations.get('Pictures')} </span>}
								{content && model && (
									<a onClick={this.onClickHandler}
									   className='red'
									   href={UrlBuilder.buildActorProfileUrl(model.name)}
									> {content && model.name}</a>
								)}
							</div>
						</div>
					</div>
					<div className="dailybonus-today-item__right-side">
						<VipBadge conditions={conditions} />
						<div className="dailybonus-today-item__right-side__icon"><OfferIcon offer={offer} purchased={purchased} /></div>
						{purchased || free || isVoucher ? (
							<div className={'dailybonus-today-item__right-side__offer-no-effect' + (free ? ' -is-free' : '')}>
								{Translations.get('PinboardContextPhotos')}
							</div>
						) : (
							<div className="dailybonus-today-item__right-side__offer-effect">
								{formatEffectAsPlainText(effect)}
							</div>
						)}
						{purchased && (
							<div className='dailybonus-today-item__right-side__title-purchased'>
								{Translations.get(free ? 'successfullypurchased_free' : 'successfullypurchased')}
							</div>
						)}
						{isVoucher && !purchased && !free && (
							<div className="dailybonus-today-item__right-side__title">
								{price.currency.toUpperCase()} <br />
								{Translations.get('Redeem')}
							</div>
						)}
						{!isVoucher && !purchased && !free && (
							<div className="dailybonus-today-item__right-side__title">
								{Translations.get(effect.name === 'Discount' ? 'Discount365' : 'Bonus365')}
							</div>
						)}
						{!isVoucher && !purchased && free && (
							<div className="dailybonus-today-item__right-side__title -is-free">
								{Translations.get('DailyBonusFreeContentSubLine')}
							</div>
						)}
						{!isVoucher && !purchased && !free && Flux.Guest.isLoggedIn() && (
							<div className="dailybonus-today-item__right-side__description">
								{content && (
									<AlbumPriceLabel
										price={price}
										discountedPrice={dailyBonusPrice}
										additionalClass="--price-big"
										purchased={purchased}
									/>
								)}
							</div>
						)}
						<DailyBonusOfferBtn
							purchased={purchased}
							offer={offer}
							content={content}
							effect={effect}
							conditions={conditions}
							quantity={quantity}
							free={free}
							isCurrencyVoucher={isVoucher}
						/>
					</div>
				</div>
			</div>
		);
	}

}

DailybonusTodayPhotoOffer.propTypes = {
	content:    PropTypes.object.isRequired,
	conditions: PropTypes.array,
	offer:      PropTypes.string.isRequired,
	purchased:  PropTypes.bool,
	free:       PropTypes.bool,
	effect:     PropTypes.object,
	quantity:   PropTypes.number,
};

DailybonusTodayPhotoOffer.defaultProps = {
	content:    {},
	conditions: [],
	purchased:  false,
	free:       false,
	effect:     {},
	quantity:   0,
};

export default DailybonusTodayPhotoOffer;
